@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <h3 style="margin-bottom: -38px" i18n>Itinerary for <span class="itv-printdate">{{chosenDate | date:'EEEE d MMMM yyyy'}}</span></h3>
    <div class="itv-controls" style="float: left; margin-left: 180px;">
      <button pButton type="button" style="height: 50px; margin-right: 5px;width: 53px; float:left;" (click)="dateChange(-7);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-double-left" style="margin-right:8px;"></span>
      </button>
      <button pButton type="button" style="height: 50px; margin-right: 5px;width: 53px; float:left;" (click)="dateChange(-1);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-left" style="margin-right:8px;"></span>
      </button>
      <div style="float:left; width: 200px;">
        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="chosenDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="dateSelected()" (onInput)="dateSelected()"></p-datepicker>
      </div>
      <button pButton type="button" style="height: 50px; margin-left: 5px;width: 53px; float:left;" (click)="dateChange(1);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-right" style="margin-right:8px;"></span>
      </button>
      <button pButton type="button" style="height: 50px; margin-left: 5px;width: 53px; float:left;" (click)="dateChange(7);" class="p-button-sm p-element p-ripple p-button p-component">
        <span class="pi pi-angle-double-right" style="margin-right:8px;"></span>
      </button>
      <div style="float:left; margin-left: 20px; width: 220px;">
        <p-multiselect [options]="resources" optionLabel="name" [(ngModel)]="chosenresources" (onPanelHide)="applyResourceFilter()" placeholder="All Resources" [style]="{'width':'200px'}"></p-multiselect>
      </div>
      <button style="height: 50px; margin-left: 5px;float:left;" pButton pRipple type="button" class="p-button-sm p-element p-ripple p-button p-component" (click)="loadgrid()" pTooltip="Refresh Data" tooltipPosition="bottom">
        <span class="pi pi-refresh"></span>
      </button>
    </div>
    <div class="itv-search" style="width:100%">
      <div style="float:right; margin-bottom: 20px;">
        <span class="p-input-icon-left ml-auto" style="margin-right:20px;">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="searchText" (input)="applyResourceFilter()" style="height: 50px;padding-left:33px;" placeholder="Name/Package/Sales ID/Resource"/>
        </span>
      </div>
    </div>
    <!-- Capacity grid. Remove this block and the showHeatmap flag to drop it. -->
    @if (showHeatmap && heatRows.length > 0) {
      <div class="surface-card p-4 shadow-2 border-round itv-heat" style="margin-top:20px;">
        <div class="itv-heat-head">
          <button type="button" class="itv-heat-toggle" (click)="heatmapOpen = !heatmapOpen">
            <span class="pi" [class.pi-chevron-down]="heatmapOpen" [class.pi-chevron-right]="!heatmapOpen"></span>
            <span>Capacity by resource and time</span>
          </button>
          @if (heatmapOpen) {
            <div class="itv-heat-key">
              <span class="itv-heat-key-label">Quieter</span>
              <span class="itv-heat-swatch itv-heat-b1"></span>
              <span class="itv-heat-swatch itv-heat-b2"></span>
              <span class="itv-heat-swatch itv-heat-b3"></span>
              <span class="itv-heat-swatch itv-heat-b4"></span>
              <span class="itv-heat-swatch itv-heat-b5"></span>
              <span class="itv-heat-key-label">Full</span>
              <span class="itv-heat-swatch itv-heat-b6"></span>
              <span class="itv-heat-key-label">Over capacity</span>
              <span class="itv-heat-swatch itv-heat-bx"></span>
              <span class="itv-heat-key-label">No capacity set</span>
            </div>
          }
        </div>
        @if (heatmapOpen) {
          <div class="itv-heat-scroll">
            <table class="itv-heat-grid">
              <thead>
                <tr>
                  <th class="itv-heat-corner">Resource</th>
                  @for (time of heatTimes; track time) {
                    <th class="itv-heat-time">{{time}}</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (row of heatRows; track row) {
                  <tr>
                    <th class="itv-heat-name" [pTooltip]="row.capacity > 0 ? (row.capacity + ' places') : 'No capacity set'" tooltipPosition="right">{{row.resourceName}}</th>
                    @for (cell of row.cells; track cell) {
                      <td
                        class="itv-heat-cell"
                        [class.itv-heat-b0]="cell.band == 0"
                        [class.itv-heat-bx]="cell.band == -1"
                        [class.itv-heat-b1]="cell.band == 1"
                        [class.itv-heat-b2]="cell.band == 2"
                        [class.itv-heat-b3]="cell.band == 3"
                        [class.itv-heat-b4]="cell.band == 4"
                        [class.itv-heat-b5]="cell.band == 5"
                        [class.itv-heat-b6]="cell.band == 6"
                        [pTooltip]="cell.tooltip" tooltipPosition="top">
                        @if (cell.band == 0) {
                          <span>&ndash;</span>
                        }
                        @if (cell.band != 0) {
                          <span>{{cell.people}}@if (cell.band == 6) {
                            <span class="pi pi-exclamation-triangle itv-heat-over-icon"></span>
                          }</span>
                        }
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    }
    @if (!ListRows || ListRows.length === 0) {
      <div style="width:100%">
        <p style="text-align:center; font-size:24px;">There are no bookings on this date.</p>
      </div>
    }
    <div class="surface-card p-4 shadow-2 border-round" style="margin-top:20px;">
      <p-table #ItineraryTable
        [columns]="cols"
        [value]="ListRows"
        responsiveLayout="scroll"
        rowGroupMode="subheader"
        groupRowsBy="resourceId"
        [customSort]="true"
        (sortFunction)="keepOrder()">
        <ng-template #caption>
          <div class="flex">
            <button
              type="button"
              pButton
              pRipple
              (click)="exportCsv()"
              class="mr-2"
              pTooltip="Export to CSV"
              tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
            </div>
          </ng-template>
          <ng-template #header>
            <tr>
              <th width="1%">&nbsp;</th>
              <th width="1%">&nbsp;</th>
              @if (showAdmitted) {
                <th width="1%">&nbsp;</th>
              }
              <th width="9%">Sales ID</th>
              <th width="6%">Start</th>
              <th width="10%">Name</th>
              <th width="14%">Email</th>
              <th width="8%">Phone</th>
              <th width="13%">Package</th>
              <th width="12%">Resource</th>
              <th width="5%">Finishes</th>
              <th width="12%">Original Itinerary</th>
              <th style="text-align: center;" width="4%">Guests</th>
              <th width="10%">Admissions</th>
              @if (showExtras) {
                <th width="10%">Extras</th>
              }
              @if (showOutstanding) {
                <th style="text-align: right;" width="6%">O/S</th>
              }
              <th width="5%">Waiver</th>
            </tr>
          </ng-template>
          <ng-template #groupheader let-rowData>
            <!-- Clicking the heading folds its section shut or opens it again. -->
            <tr style="cursor:pointer;" (click)="toggleSection(rowData)">
              <td colspan="17" style="font-size:18px; font-weight:bold; background-color:#f6f6f6;">
                <span class="pi" [class.pi-chevron-down]="!collapsed.has(rowData.resourceId)" [class.pi-chevron-right]="collapsed.has(rowData.resourceId)" style="margin-right:8px;"></span>{{sectionTitle(rowData)}}
              </td>
            </tr>
          </ng-template>
          <ng-template #body let-rowData>
            @if (!collapsed.has(rowData.resourceId)) {
            <!-- A timeslot sub-heading inside the resource section, drawn once per slot. -->
            @if (rowData.firstOfSlot) {
              <tr>
                <td colspan="17" style="font-weight:bold; padding-left:24px; background-color:#fbfbfb;">
                  <span class="pi pi-clock" style="margin-right:8px;"></span>{{rowData.timeslot}}
                  @if (showCapacity) {
                    <span style="font-weight:normal; color:#6b7280; margin-left:12px;">
                      {{rowData.slotBookings}} {{rowData.slotBookings == 1 ? 'booking' : 'bookings'}}
                      @if (rowData.slotCapacity > 0) {
                        <span> &middot; {{rowData.slotPeople}} of {{rowData.slotCapacity}} places</span>
                      }
                      @if (rowData.slotCapacity == 0) {
                        <span> &middot; {{rowData.slotPeople}} {{rowData.slotPeople == 1 ? 'person' : 'people'}}</span>
                      }
                    </span>
                  }
                </td>
              </tr>
            }
            <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'"
              onmouseout="this.style.backgroundColor=this.originalstyle;"
              [ngStyle]="{'background-color': rowData.disabled ? '#fee' : ((rowData.allergy != null && rowData.allergy != '') ? '#FFFFB2' : '#ffffff')}"
              style="cursor:pointer;"
              (click)="editdata(rowData.bookingId)">
              <td>
                @if (rowData.publicBooking) {
                  <span class="pi pi-user" pTooltip="Booked online"></span>
                }
              </td>
              <td>
                @if (rowData.notes != '' && rowData.notes != null) {
                  <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{rowData.notes}}"></span>
                }
              </td>
              @if (showAdmitted) {
                <td>
                  @if (rowData.checkedin) {
                    <span style="color:#22c55e;" class="pi pi-check-circle" pTooltip="Admitted"></span>
                  }
                </td>
              }
              <td>{{rowData.bookingIdHR}}</td>
              <td>{{rowData.startTime}}</td>
              <td>{{rowData.name}}</td>
              <td>{{rowData.email}}</td>
              <td>{{rowData.phone}}</td>
              <td>{{rowData.packageName}}</td>
              <td>{{rowData.resourceLabel}}</td>
              <td>{{rowData.endtime}}</td>
              <td style="white-space: pre-line;">{{rowData.itinerary}}</td>
              <td style="text-align: right;">{{rowData.guests}}</td>
              <td>{{rowData.admissions}}</td>
              @if (showExtras) {
                <td>{{rowData.extras}}</td>
              }
              @if (showOutstanding) {
                <td style="text-align: right;">
                  @if (rowData.outstanding > 0) {
                    <span style="color: Red; font-weight: bold;">{{rowData.outstanding | currency: (rowData.currency || 'GBP')}}</span>
                  }
                  @if (rowData.outstanding <= 0) {
                    <span>{{rowData.outstanding | currency: (rowData.currency || 'GBP')}}</span>
                  }
                </td>
              }
              <td>{{rowData.waiver}}</td>
            </tr>
            }
          </ng-template>
        </p-table>
      </div>
    </div>
  }
